import * as Sentry from '@sentry/nextjs';

export type LayoutDiagnosticsPhase =
  | 'layout-init-start'
  | 'layout-init-complete'
  | 'layout-init-error'
  | 'layout-header-mounted'
  | 'search-mounted'
  | 'search-suggestions-failed'
  | 'search-saved-searches-failed'
  | 'mobile-search-opened'
  | 'sticky-search-opened'
  | 'user-menu-mounted'
  | 'logged-out-menu-mounted'
  | 'mobile-nav-opened'
  | 'in-app-notifications-fetch-failed'
  | 'seller-menu-mounted'
  | 'seamless-registration-opened'
  | 'seamless-registration-tracking-skipped'
  | 'seamless-registration-tracking-fired'
  | 'seamless-registration-cta-clicked';

export interface LayoutDiagnosticsEvent {
  phase: LayoutDiagnosticsPhase;
  message: string;
  context?: Record<string, string | number | boolean | null | undefined>;
}

type DiagnosticsDisposition = 'breadcrumb' | 'warning' | 'error';

const phaseDisposition: Record<
  LayoutDiagnosticsEvent['phase'],
  DiagnosticsDisposition
> = {
  'layout-init-start': 'breadcrumb',
  'layout-init-complete': 'breadcrumb',
  'layout-init-error': 'error',
  'layout-header-mounted': 'breadcrumb',
  'search-mounted': 'breadcrumb',
  'search-suggestions-failed': 'warning',
  'search-saved-searches-failed': 'warning',
  'mobile-search-opened': 'breadcrumb',
  'sticky-search-opened': 'breadcrumb',
  'user-menu-mounted': 'breadcrumb',
  'logged-out-menu-mounted': 'breadcrumb',
  'mobile-nav-opened': 'breadcrumb',
  'in-app-notifications-fetch-failed': 'warning',
  'seller-menu-mounted': 'breadcrumb',
  'seamless-registration-opened': 'breadcrumb',
  'seamless-registration-tracking-skipped': 'warning',
  'seamless-registration-tracking-fired': 'breadcrumb',
  'seamless-registration-cta-clicked': 'breadcrumb',
};

export const reportLayoutDiagnostics = (
  event: LayoutDiagnosticsEvent
): void => {
  const disposition = phaseDisposition[event.phase];

  if (disposition === 'breadcrumb') {
    Sentry.addBreadcrumb({
      category: 'layout',
      level: 'info',
      message: event.message,
      data: {
        phase: event.phase,
        ...event.context,
      },
    });
    return;
  }

  Sentry.captureMessage(event.message, {
    level: disposition,
    tags: {
      feature: 'layout',
      phase: event.phase,
    },
    extra: event.context,
  });
};
